/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The possible deployment states. The possible transitions are::
 * DEPLOYING -> RUNNING:
 * The deployment succeeded, and now the app is actually running.
 * DEPLOYING -> STOPPED:
 * If the user stopped the deployment before the app began running.
 * DEPLOYING -> FAILED:
 * If the deployment failed.
 * DEPLOYING -> SUPPORT_REQUESTED:
 * If there is a failure in deployment, but we don't want the user(s)
 * to immediately be able to create a new `AppInstance` (likely an
 * infrastructure error, such as a bad coderunner image or similar).
 * RUNNING -> FAILED:
 * If the app completes execution, or the user triggers it to
 * be stopped manually.
 * RUNNING -> STOPPED:
 * If either the app completes execution, or the user triggers it to
 * be stopped manually.
 * RUNNING -> SUPPORT_REQUIRED:
 * If there is a failure in execution, but we don't want the user(s)
 * to immediately be able to create a new `AppInstance` (likely a
 * synthesis error requiring support).
 * SUPPORT_REQUIRED -> READY:
 * Triggered once support has unlocked an app to be ready to be
 * deployed again.
 *
 * So effectively `DEPLOYING` is the starting state, and there are terminal
 * states of  `STOPPED`, `FAILED`, or `READY`. This is because a new
 * `AppInstance` is created whenever a deployment begins, and that is blocked
 * from happening unless one of the terminal states is reached (to avoid
 * duplicated deployments).
 *
 * The use of `SUPPORT_REQUESTED` and `READY` is to
 * (i) create a smoother UX than a hard failure.
 * (ii) to prevent users from spamming deployments of apps that will fail.
 * These states are reached if the deployment fails in `SupervisionHandler`,
 * and then support unblocks it in `allow_deployment_support`.
 *
 * The transition into the `READY` state must be initiated by a dev user
 * through the `allow_deployment_support` route.
 */
export var DeploymentState;
(function (DeploymentState) {
    DeploymentState["DEPLOYING"] = "deploying";
    DeploymentState["RUNNING"] = "running";
    DeploymentState["STOPPED"] = "stopped";
    DeploymentState["FAILED"] = "failed";
    DeploymentState["READY"] = "ready";
    DeploymentState["SUPPORT_REQUIRED"] = "support-required";
})(DeploymentState || (DeploymentState = {}));
